import {AfterViewInit, Component, ElementRef, Injector, OnInit, ViewChild} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AdminService} from "../dashboard/services/admin.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {FileStorageService} from "../../_services/filestorage.service";

@Component({
    selector: 'app-admin-conversation',
    templateUrl: './admin-conversation.component.html',
    styleUrls: ['../../scss/office.scss', './admin-board.component.scss']
})
export class AdminConversationComponent extends BaseComponentDirective implements OnInit, AfterViewInit {
    ticket: any = {};
    user: any = {};
    form: FormGroup;
    fileUrl: string | ArrayBuffer;
    fd: FormData;
    uploading = false;
    hasAttachment = false;
    @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
    constructor(
        injector: Injector,
        private adminService: AdminService,
        private formBuilder: FormBuilder,
        private fileStorageService: FileStorageService,
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            message: [null, [Validators.required, Validators.minLength(5)]]
        })
    }

    override ngOnInit() {
        super.ngOnInit();
        this.profileMsg.currentMessage.subscribe(r => {
            if(r) {
                this.user = r;
                this.callConversation();
                setTimeout(() => this.scrollToBottom(), 2000);
            }
        });

    }

    ngAfterViewInit() {
        setTimeout(() => this.scrollToBottom(), 2000);
    }

    callConversation() {
        this.adminService.getWalletSupportDetails(this.activatedRoute.snapshot.params.id).then(r => {
            this.ticket = r;
            this.ticket.walletSupportDetails.sort((a:any, b:any) => a.id - b.id);
        })
    }
    downloadAttachment(attachmentId: number, fileName: string) {
        this.fileStorageService.getAttachmentUrlAdmin(attachmentId, fileName);
    }

    private scrollToBottom(): void {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight + 150;
    }

    sendMessage() {
        if(this.ticket.status == 'OPEN') {

            const validation = this.check(this.form);
            if(validation) {
                this.showAlertDark('Warning', '', 'Please complete all required fields. Your message cannot be empty, and it must be at least 5 characters long.');
                return;
            }

            this.uploading = true;
            this.form.controls.message.disable();

            this.adminService.replyWalletSupportTicket(
                this.form.controls.message.value,
                this.activatedRoute.snapshot.params.id,
                false
            ).then(r => {
                if(this.hasAttachment) {
                    this.adminService.uploadFileAttachmentAdmin(this.fd, r.id).then(_ => {
                        this.callConversation();
                        this.showAlertDark('Message Submitted', 'Your message has been saved successfully', 'You will get notification if our administrator ready to reply your message through your email');
                        this.snackBar.open('Message has been saved successfully', null, {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'});
                        this.form.reset();
                        this.form.markAsPristine();
                        this.form.markAsUntouched();
                        this.form.controls.message.enable();
                        this.uploading = false;
                        this.fd = new FormData();
                        this.fileUrl = null;
                        this.hasAttachment = false;
                        setTimeout(() => this.scrollToBottom(), 2000);
                    });
                } else {
                    this.callConversation();
                    this.showAlertDark('Message Submitted', 'Your message has been saved successfully', 'An email notification will be sent to both member and administrator');
                    this.snackBar.open('Message has been saved successfully', null, {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'});
                    this.form.reset();
                    this.form.markAsPristine();
                    this.form.markAsUntouched();
                    this.form.controls.message.enable();
                    this.uploading = false;
                    this.fd = new FormData();
                    this.fileUrl = null;
                    this.hasAttachment = false;
                    setTimeout(() => this.scrollToBottom(), 2000);
                }

            });
        } else {
            this.showAlertDark('Information', 'This ticket is closed and you no longer able to send message to this conversation', 'Please open new ticket if you still have any question')
        }

    }

    goBack() {
        this.router.navigate(['/office/inbox']).then();
    }

    getFileChange($event: FileList): void {
        this.fd = new FormData();
        const fileTransfer = $event[0];
        this.fd.append('file', fileTransfer);
        this.form.controls.message.setValue(this.form.controls.message.value?? " " + " a file attached to message")
    }

    closeTicket() {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: 'Are you sure want to close this ticket?',
                subMessage: 'Both admin and member can no longer reply to this ticket conversation',
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Yes, Close Ticket',
                theme: 'dark'
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            this.adminService.closeWalletSupportTicket(this.activatedRoute.snapshot.params.id).then(r => {
                this.callConversation();
                this.showAlertDark('Message Submitted', 'Ticket has been closed successfully', 'An email notification will be sent to both member and administrator');
                this.snackBar.open('Message has been closed successfully', null, {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'});
                this.form.reset();
                this.form.markAsPristine();
                this.form.markAsUntouched();
            })
        });
    }
}
